var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.154b623824206e5096bc2c50696ff78c.svg#q';
                    var viewUrl = 'sprites.154b623824206e5096bc2c50696ff78c.svg#view-q';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 28',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };